import { ActivityLogState } from "./types";

export function getDefaultState(): ActivityLogState {
    return {
        emptyState: true,
        selectedSites:[]
    }
}